import { TbInbox } from "react-icons/tb";

function EmptyState({ label = "Nothing in here", className = "" }) {
	return (
		<div className={`p-6 flex-center w-full col-span-full text-secondary ${className}`}>
			<div className="flex flex-col items-center gap-3 text-center floating">
				<div className="flex items-center justify-center w-12 h-12 rounded-full border border-dashed border-surface/80 bg-light/80 text-secondary shadow-sm">
					<TbInbox className="w-6 h-6" aria-hidden="true" />
				</div>
				<div className="text-xs sm:text-sm font-medium">{label}</div>
			</div>
		</div>
	);
}

export default EmptyState;
